<template>
  <div :class="$style.container">
    <h2 id="title-linkMixPanel">
      {{ title }}
    </h2>
    <div :class="[$style.wrapper, $style[current === index ? 'isFocus' : '']]">
      <div v-if="!isAccessible" :class="$style.layer"></div>
      <div :class="$style.field">
        <p :class="$style.title">Mixpanel Project ID</p>
        <p :class="$style.subtext">
          The Project ID can be found in Mixpanel in the Overview section of the Project Settings.
        </p>
        <el-input v-model="projectId" placeholder="Enter your MixPanel Project ID"/>
      </div>
      <p :class="$style.title">Mixpanel Service Account</p>
      <div :class="$style.subsection">
        <div :class="$style.field">
          <p :class="$style.subtitle">Service Account name</p>
          <p :class="$style.subtext">
            You can create a Service Account in Mixpanel in the Service Accounts section of the Project Settings.
          </p>
          <el-input v-model="serviceAccountName" size="small" placeholder="Enter the Service Account name"/>
        </div>
        <div :class="$style.field">
          <p :class="$style.subtitle">Service Account secret</p>
          <el-input
            v-model="serviceAccountSecret"
            type="password"
            placeholder="Enter the Service Account secret"/>
        </div>
      </div>
      <el-button
        id="validate-mixpanel"
        type="primary"
        size="small"
        :disabled="!canValidate"
        :class="$style.validateBtn"
        data-test-id="gameSubmissionFacebookSetupValidate"
        @click="validate"
      >
        <span>Validate</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import actionList from '@/static/actionList';
import tools from '@/tools/tools';
import { cloneDeep } from 'lodash';

export default {
  name: 'MixPanelStepOnPage',
  components: {},
  props: {
    game: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: 'no name',
    },
    current: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    step: {
      type: Object,
      default: null,
    },
    steps: {
      type: Array,
      default: null,
    },
    warning: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      actionList,
      errorBack: [],
      loading: false,
      projectId: this.game?.mixpanel?.projectId ?? '',
      serviceAccountName: this.game?.mixpanel?.serviceAccountName ?? '',
      serviceAccountSecret: '',
    };
  },
  computed: {
    codification() {
      return this.$store.getters['users/codification'] || null;
    },
    isAccessible() {
      return this.index === 0 || this.steps[this.index - 1].isValid;
    },
    canValidate() {
      return this.serviceAccountSecret && this.serviceAccountName && this.projectId;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    tools.attachEvent(
      document.getElementById('container-scrollable'),
      'scroll',
      this.update,
    );
    tools.attachEvent(window, 'resize', this.update);
  },
  methods: {
    async validate() {
      console.log(this.game);
      this.loading = true;

      await this.$store.dispatch('submitGame/setNextStepLoadingProperty', true);

      try {
        await this.integrateMixPanel({
          projectId: this.projectId,
          serviceAccountName: this.serviceAccountName,
          serviceAccountSecret: this.serviceAccountSecret,
        });
      } catch {
        return;
      }

      await this.$store.dispatch(
        'submitGame/setNextStepLoadingProperty',
        false,
      );


      this.$emit('isValid', this.index);
    },
    update() {
      const titleElement = document.getElementById('title-linkToStore');
      const isVisible = tools.visibleY(titleElement);
      if (this.isvisible !== isVisible) {
        if (this.isAccessible && isVisible) {
          this.$emit('change', this.index);
        }
        this.isvisible = isVisible;
      }
    },
    attachEvent(element, event, callbackFunction) {
      if (element.addEventListener) {
        element.addEventListener(event, callbackFunction, false);
      } else if (element.attachEvent) {
        element.attachEvent(`on${event}`, callbackFunction);
      }
    },
    integrateMixPanel({
      projectId,
      serviceAccountName,
      serviceAccountSecret,
    }) {
      return new Promise(async (resolve, reject) => {
        const action = this.actionList.filter(
          el => el.id === 'integrate_mix_panel',
        )[0];
        action.post.field[0].value = projectId;
        action.post.field[1].value = serviceAccountName;
        action.post.field[2].value = serviceAccountSecret;
        const param = {
          id: cloneDeep(this.game.id),
          action,
        };
        const response = await this.$store.dispatch(
          'ActionToDispatch/dispatchAction',
          param,
        );
        if (response.isSuccess) {
          resolve(true);
        } else {
          const errorList = this.codification.errorList;
          this.errorBack = [errorList.GAME_ANALYTICS_GAME_NOT_FOUND.message];
          reject(response.reason);
        }
      });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: $spacing * 3;
  display: block;

  h2 {
    font-size: 16px;
    padding-bottom: 16px;
    text-align: left;
  }
}

.isFocus {
  -webkit-box-shadow: 0px 0px 19px 3px rgba(0, 0, 0, 0.10);
  box-shadow: 0px 0px 19px 3px rgba(0, 0, 0, 0.10);
}

.wrapper {
  border-radius: 16px;
  border: solid 1px $foggy-grey;
  text-align: left;
  font-size: 12px;
  padding: $spacing * 3;
  padding-top: 0;
  position: relative;

  .layer {
    border-radius: 16px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(255 255 255 / 80%);
    z-index: 10;
  }
}

.title {
  margin: $spacing 0;
  font-weight: 600;
}

.subtitle {
  margin: $spacing 0 $spacing 0;
  font-weight: 600;
}

.subtext {
  color: $grey;
  line-height: 1;
  margin: $spacing 0 $spacing 0;
}

.subsection {
  padding-left: $spacing * 2;
}

.validateBtn {
  margin-top: $spacing * 3;
}

.notice {
  margin-top: $spacing * 3;
}

.field {
  margin: $spacing * 2 0;
}
</style>
